import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { selectionsDisplayDeleteItem, selectionsUpdateItemShowInApp, uiProgramSetEditSelection } from '../../actions'
import toJS from '../../hoc/toJS'
import SelectionDisplay from '../../components/PageProgram/SelectionDisplay'
import getData from '../../functions/getData'
import { PROGRAM_CINEMAS, CLI_MULTICINEMA_MODE, FEATURES, PROGRAM_SELECTIONS_ITEMS } from '../../constants/state'



const mapStateToProps = (state, ownProps) => ({
    selection: getData(state, [PROGRAM_SELECTIONS_ITEMS, ownProps.displaySelection.selectionPk]),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    cliMulticinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    activeSelection: state.getIn(['ui', 'program', 'activeSelection']),
    features: getData(state, FEATURES)
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    setActiveSelection: (activeClass, id) => {
        const activeTabID = activeClass === "accordion-item-open" ? '' : id
		dispatch(programSetActiveSelection(activeTabID))
    },
    onUpdateSelectionShowInApp: (pk, bool) => {
        dispatch(selectionsUpdateItemShowInApp(pk, bool))
    },
    deleteSelection: () => {
        if(true === ownProps.enableDeleteSelection) {
            dispatch(selectionsDisplayDeleteItem(ownProps.id))
        }
    },
    onEditSelectionSettings: (selectionId) => {
        if(selectionId) {
            dispatch(uiProgramSetEditSelection(selectionId, ownProps.displaySelection.type))
        }
    }
 })

 const SelectionDisplayContainer = ({enableDeleteSelection, displaySelection, selection, cliCinemas, cliMulticinemaMode, activeSelection, features, setActiveSelection, onUpdateSelectionShowInApp, deleteSelection, onEditSelectionSettings}) => (
    <SelectionDisplay 
        enableDeleteSelection={enableDeleteSelection}
        displaySelection={displaySelection}
        selection={selection}
        cliCinemas={cliCinemas}
        cliMulticinemaMode={cliMulticinemaMode}
        activeSelection={activeSelection}
        features={features}
        setActiveSelection={setActiveSelection}
        onUpdateSelectionShowInApp={onUpdateSelectionShowInApp}
        deleteSelection={deleteSelection}
        onEditSelectionSettings={onEditSelectionSettings}
    />
)
export default compose(
    connect(mapStateToProps, null),
    connect(null, mapDispatchToProps),
    toJS()
)(SelectionDisplayContainer)